import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DoctorSocialComponent } from './doctor-social.component';
import { AuthGardService } from 'src/security/auth-gard.service';
import { MySocialActivityComponent } from '../my-social-activity/my-social-activity.component';
import { PostDetailsComComponent } from './post-details-com/post-details-com.component';

const routes: Routes = [
  {
    path : 'activity',
    component : DoctorSocialComponent
  },
  {
    path : 'post/:feedId',
    component : PostDetailsComComponent
  },
  {
    path : 'profile',
    component : MySocialActivityComponent,
    canActivate : [AuthGardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DoctorSocialRoutingModule { }
